module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/356.b0f788e9.png";